import { type DirectionFilter as DirectionFilterValue, DIRECTION_OPTIONS } from './types';

interface DirectionFilterProps {
  value: DirectionFilterValue;
  onChange: (value: DirectionFilterValue) => void;
}

export function DirectionFilter({ value, onChange }: DirectionFilterProps) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as DirectionFilterValue)}
      className="rounded-md border border-[#e0e0e0] bg-white px-3 py-2 text-[12px] font-medium text-[#333] focus:border-[#6B0F1A] focus:outline-none focus:ring-1 focus:ring-[#6B0F1A]"
      aria-label="Filter by direction"
      data-testid="direction-filter"
    >
      {DIRECTION_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
